<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';

const canvas = ref(null);
const canvasIsVisible = useElementVisibility(canvas);
const isVisible = ref(false);

watch(canvasIsVisible, (val) => {
  if (val === true) {
    isVisible.value = true;
  }
});

defineOptions({
  name: 'PageHomeHighlights',
});
</script>

<template>
  <section class="page-home-highlights mt-128px">
    <div class="mx-auto w-1200px">
      <h2 class="text-32px color-hex-00479d font-medium">
        <span class="block leading-45px">峰会亮点</span>
        <small class="mt-2px block text-14px leading-20px uppercase">Highlights</small>
      </h2>

      <div class="canvas relative mt-31px h-873px w-1200px" ref="canvas">
        <svg class="absolute" viewBox="0 0 1200 873" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path :class="{ 'line-animation': isVisible }" d="M160 148L160 220C160 222.209 161.791 224 164 224L556 224C558.209 224 560 225.791 560 228L560 320" stroke="#38A1DB" stroke-width="2.000000" stroke-linejoin="round" stroke-linecap="round" />
          <path class="line-animation-delay1" :class="{ 'line-animation': isVisible }" d="M560 448L560 490C560 492.209 558.209 494 556 494L504 494" stroke="#38A1DB" stroke-width="2.000000" stroke-linejoin="round" stroke-linecap="round" />
          <path class="line-animation-delay2" :class="{ 'line-animation': isVisible }" d="M176 752L176 812C176 814.209 177.791 816 180 816L480 816" stroke="#38A1DB" stroke-width="2.000000" stroke-linejoin="round" stroke-linecap="round" />
        </svg>
        <div class="animate__animated box-up absolute left-0 right-0 top-0 z-1 h-200px w-full bg-right bg-no-repeat opacity-0" :class="{ animate__fadeInDown: isVisible }">
          <h3 class="text-50px color-[rgba(0,71,157,0.2)] font-thin leading-1em">在这里你能够</h3>
          <h4 class="mt-18px text-24px color-hex-2d2d2d font-medium leading-32px">看·全球开源趋势</h4>
          <p class="mt-8px text-16px color-hex-2d2d2d leading-24px">前沿科学家、技术领袖揭秘顶尖的开源趋势</p>
        </div>
        <div class="animate__animated box-right absolute right-0 top-248px z-2 h-320px w-640px bg-right bg-no-repeat opacity-0" :class="{ animate__fadeInRight: isVisible }">
          <h4 class="mt-96px text-24px color-hex-2d2d2d font-medium leading-32px">论·开源前沿观点</h4>
          <p class="mt-8px w-320px text-16px color-hex-2d2d2d leading-24px">与国际嘉宾、行业专家探讨开源领域最前沿的思想与理论</p>
        </div>
        <div class="animate__animated box-down absolute bottom-0 right-0 z-3 h-345px w-667px bg-contain bg-no-repeat opacity-0" :class="{ animate__fadeInUp: isVisible }">
          <div class="absolute bottom-57px right-0">
            <h4 class="text-24px color-hex-2d2d2d font-medium leading-32px">浸·全沉浸式体验</h4>
            <p class="mt-8px w-320px text-16px color-hex-2d2d2d leading-24px">体验沉浸式、全链路的线上+线下观展体验</p>
          </div>
        </div>
        <div class="animate__animated box-left absolute left-0 top-248px h-480px w-520px bg-no-repeat opacity-0" :class="{ animate__fadeInLeft: isVisible }">
          <div class="absolute bottom-40px right-0">
            <h4 class="text-24px color-hex-2d2d2d font-medium leading-32px">促·开发者生态交流</h4>
            <p class="mt-8px w-320px text-16px color-hex-2d2d2d leading-24px">与开发者大咖、技术创作者学习交流</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-home-highlights {
  .line-animation {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: dash 1s linear forwards;
  }

  .line-animation-delay1 {
    animation-delay: 0.8s;
  }

  .line-animation-delay2 {
    animation-delay: 1s;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0;
    }
  }

  .box-up {
    background-image: url(@@summit/2023/assets/home/highlights/bg-1.svg);
  }

  .box-right {
    background-image: url(@@summit/2023/assets/home/highlights/bg-2.svg);
  }

  .box-down {
    background-image: url(@@summit/2023/assets/home/highlights/bg-3.svg);
  }

  .box-left {
    background-image: url(@@summit/2023/assets/home/highlights/bg-4.svg);
  }
}
</style>
